export default "__VITE_ASSET__n43RJ99b__"